import React from "react";
import logo from "../../utils/images/zostelLogo.svg";

import "./styles.css";

const Logo = () => {
  return <img className="logo" src={logo} alt="Zostel" />;
};

export default Logo;
